const UUID_SEGMENT =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const FIRESTORE_LIKE_ID = /^[A-Za-z0-9]{20,}$/;

const ROUTE_TEMPLATES = [
  [/^\/projects\/new(?:\/)?$/, "/projects/new"],
  [/^\/projects\/[^/]+$/, "/projects/:id"],
  [/^\/viewer\/[^/]+$/, "/viewer/:id"],
  [/^\/u\/[^/]+$/, "/u/:slug"],
  [/^\/u\/[^/]+\/project\/[^/]+$/, "/u/:slug/project/:id"],
  [/^\/u\/[^/]+\/project\/[^/]+\/image\/[^/]+$/, "/u/:slug/project/:id/image/:id"],
  [/^\/share\/project\/[^/]+$/, "/share/project/:id"],
  [/^\/share\/project\/[^/]+\/image\/[^/]+$/, "/share/project/:id/image/:id"],
  [/^\/share\/standalone\/[^/]+$/, "/share/standalone/:id"],
  [/^\/share\/image\/[^/]+$/, "/share/image/:id"],
  [/^\/embed\/[^/]+$/, "/embed/:id"],
  [/^\/embed\/[^/]+\/image\/[^/]+$/, "/embed/:id/image/:id"],
];

/**
 * Remove query, hash e identificadores de rota antes de enviar page_view.
 *
 * @param {string} [input]
 * @returns {string}
 */
export function sanitizePagePath(input) {
  if (typeof input !== "string" || !input.trim()) {
    return "/";
  }

  let path = input.trim();

  try {
    if (/^https?:\/\//i.test(path)) {
      path = new URL(path).pathname;
    }
  } catch {
    path = path.split("?")[0].split("#")[0];
  }

  const queryIndex = path.indexOf("?");
  if (queryIndex >= 0) {
    path = path.slice(0, queryIndex);
  }
  const hashIndex = path.indexOf("#");
  if (hashIndex >= 0) {
    path = path.slice(0, hashIndex);
  }

  if (!path.startsWith("/")) {
    path = `/${path}`;
  }

  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }

  for (const [pattern, template] of ROUTE_TEMPLATES) {
    if (pattern.test(path)) {
      return template;
    }
  }

  const sanitized = path
    .split("/")
    .map((segment) => {
      if (!segment) {
        return segment;
      }
      if (segment.includes("@")) {
        return ":redacted";
      }
      if (UUID_SEGMENT.test(segment) || FIRESTORE_LIKE_ID.test(segment)) {
        return ":id";
      }
      return segment;
    })
    .join("/");

  return sanitized || "/";
}
